import { Injectable } from '@angular/core';
import { ParentService } from '../A2-utils/ParentClass/ParentService';
import { Http } from '@angular/http';
import { constant } from 'app/app.constants';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class SkillsService extends ParentService {

  constructor(private http: Http, private route: Router) {
    super();
  }

  /**
   * this get all skills
   */
  getSkills() {
    return this.http.get(constant.URL_SKILL, this.getHeader())
      .map(res => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

  /**
   * this get all skills
   */
  getSkillByID(skillid) {
    return this.http.get(constant.URL_SKILL + `/${skillid}`, this.getHeader())
      .map(res => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

  /**
   * this save skill into db
   * @param data data to save
   */
  saveSkill(data) {
    return this.http.post(constant.URL_SKILL, data, this.headerPost())
      .map(res => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

  /**
   * this update skill into db
   * @param data data to update
   */
  updateSkill(data) {
    return this.http.put(constant.URL_SKILL, data, this.headerPost())
      .map(res => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/autorouting/skills.service.ts